import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-block" }
const _hoisted_2 = { class: "d-block pt-2" }
const _hoisted_3 = { class: "form-label fw-bolder" }
const _hoisted_4 = {
  value: "",
  selected: ""
}
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "form-label fw-bolder" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = { class: "d-flex justify-content-end mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputClearable = _resolveComponent("FormInputClearable")!
  const _component_Btn = _resolveComponent("Btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createElementVNode("label", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('FavoriteViewsSaveTo')), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.favoriteID) = $event)),
          class: "form-select"
        }, [
          _createElementVNode("option", _hoisted_4, _toDisplayString(_ctx.t('FavoriteViewsNew')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.favoriteViews, (item) => {
            return (_openBlock(), _createElementBlock("option", {
              key: item.id,
              value: item.id
            }, _toDisplayString(item.code), 9, _hoisted_5))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.favoriteID]
        ])
      ]),
      _withDirectives(_createElementVNode("label", {
        class: _normalizeClass(["pt-2", { 'd-block': !_ctx.favoriteID }])
      }, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t('FavoriteViewsCode')), 1),
        _createVNode(_component_FormInputClearable, {
          modelValue: _ctx.favoriteCode,
          validators: _ctx.validators.favoriteCode,
          "onUpdate:modelValue": _ctx.onFavoriteCodeUpdate
        }, null, 8, ["modelValue", "validators", "onUpdate:modelValue"])
      ], 2), [
        [_vShow, !_ctx.favoriteID]
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Btn, {
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('on-form-cancel')), ["prevent"])),
          class: "mx-2"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('Cancel', true)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Btn, {
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.onUpdate(true)), ["prevent"])),
          disabled: !_ctx.isFormValid,
          primary: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('Save', true)), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ], 32)
  ]))
}